<template>
    <QRCodeGenerator></QRCodeGenerator>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const QRCodeGenerator = defineAsyncComponent(() =>
    import(
        "../../components/ProjectManagement/QRCodeGenerator/QRCodeGenerator.vue"
    )
);

export default {
    name: "qr_code_generator",
    components: { QRCodeGenerator, AuthLayout },
};
</script>
